import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AtokuReportsComponent } from "@features/atoku/atoku-reports/atoku-reports.component";
import { AtokuCalendarComponent } from "@features/atoku/atoku-calendar/atoku-calendar.component";
import { AtokuStorageEquipmentComponent } from "@features/atoku/atoku-storage-equipment/atoku-storage-equipment.component";
import { AtokuUsersComponent } from "@features/atoku/atoku-users/atoku-users.component";
import { AtokuStationsComponent } from "@features/atoku/atoku-stations/atoku-stations.component";
import { AtokuAccessRequestsComponent } from "@features/atoku/atoku-access-requests/atoku-access-requests.component";
import { AtokuEquipmentComponent } from "@features/atoku/atoku-equipment/atoku-equipment.component";
import { AtokuStorageComponent } from "@features/atoku/atoku-storage/atoku-storage.component";
import { AtokuCategoriesComponent } from "@features/atoku/atoku-categories/atoku-categories.component";
import { AtokuPricingProfilesComponent } from "@features/atoku/atoku-pricing-profiles/atoku-pricing-profiles.component";
import { AtokuBookingConfigComponent } from "@features/atoku/atoku-booking-config/atoku-booking-config.component";
import { AtokuAccessManagementComponent } from "@features/atoku/atoku-access-management/atoku-access-management.component";
import { AtokuAccessEntriesComponent } from "@features/atoku/atoku-access-entries/atoku-access-entries.component";
import { EditEquipmentDialogComponent } from "@features/atoku/atoku-storage-equipment/dialogs/edit-equipment-dialog/edit-equipment-dialog.component";
import { EditStationDialogComponent } from "@features/atoku/atoku-stations/dialogs/edit-station-dialog/edit-station-dialog.component";
import { GiveAccessDialogComponent } from "@features/atoku/atoku-users/dialogs/give-access-dialog/give-access-dialog.component";
import {
    DepositDeductionDialogComponent
} from "@features/atoku/atoku-users/dialogs/deposit-deduction-dialog/deposit-deduction-dialog.component";
import { CreatePricingProfileDialogComponent } from "@features/atoku/atoku-pricing-profiles/dialogs/create-pricing-profile-dialog/create-pricing-profile-dialog.component";
import { EditPricingProfileDialogComponent } from "@features/atoku/atoku-pricing-profiles/dialogs/edit-pricing-profile-dialog/edit-pricing-profile-dialog.component";
import { EditCategoryDialogComponent } from "@features/atoku/atoku-categories/dialogs/edit-category-dialog/edit-category-dialog.component";
import { DeclineAccessRequestDialogComponent } from "@features/atoku/atoku-access-requests/dialogs/decline-access-request-dialog/decline-access-request-dialog.component";
import {
    TermsAndConditionsDialogComponent
} from "@features/atoku/atoku-booking-config/dialogs/terms-and-conditions-dialog/terms-and-conditions-dialog.component";
import {
    EmailTemplateDialogComponent
} from "@features/atoku/atoku-booking-config/dialogs/email-template-dialog/email-template-dialog.component";
import {
    StatementPeriodDialogComponent
} from "@features/atoku/atoku-reports/dialogs/statement-period-dialog/statement-period-dialog.component";
import { MaterialModule } from "@modules/material.module";
import { AppSharedModule } from "@modules/app-shared.module";
import { AppCoreModule } from "@modules/app.core.module";
import { CrudTableComponent } from "@ui-kit/webkit/components/crud-table/crud-table.component";


@NgModule({
    declarations: [
        AtokuReportsComponent,
        AtokuCalendarComponent,
        AtokuStorageEquipmentComponent,
        AtokuUsersComponent,
        AtokuStationsComponent,
        AtokuAccessRequestsComponent,
        AtokuEquipmentComponent,
        AtokuStorageComponent,
        AtokuCategoriesComponent,
        AtokuPricingProfilesComponent,
        AtokuBookingConfigComponent,
        AtokuAccessManagementComponent,
        AtokuAccessEntriesComponent,
        EditEquipmentDialogComponent,
        GiveAccessDialogComponent,
        DepositDeductionDialogComponent,
        EditStationDialogComponent,
        CreatePricingProfileDialogComponent,
        EditPricingProfileDialogComponent,
        EditCategoryDialogComponent,
        DeclineAccessRequestDialogComponent,
        TermsAndConditionsDialogComponent,
        EmailTemplateDialogComponent,
        StatementPeriodDialogComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        AppSharedModule,
        AppCoreModule,
        CrudTableComponent
    ],
    exports: [
        AtokuReportsComponent,
        AtokuCalendarComponent,
        AtokuStorageEquipmentComponent,
        AtokuUsersComponent,
        AtokuStationsComponent,
        AtokuAccessRequestsComponent,
        AtokuEquipmentComponent,
        AtokuStorageComponent,
        AtokuCategoriesComponent,
        AtokuPricingProfilesComponent,
        AtokuBookingConfigComponent,
        AtokuAccessManagementComponent,
        AtokuAccessEntriesComponent
    ]
})
export class FeatureAtokuModule { }
